var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Page")]),_c('h3',[_vm._v("New Page")]),_c('PageForm',{attrs:{"parent-values":_vm.pagesParentValues},on:{"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }